import React from 'react';
import { motion } from 'framer-motion';
import { FrownIcon, MoonIcon, WindIcon, BrainIcon, HeartIcon, BatteryLowIcon } from 'lucide-react';
const symptoms = [{
  icon: FrownIcon,
  text: 'La báscula no se mueve aunque comas ensaladas'
}, {
  icon: MoonIcon,
  text: 'Te despiertas a las 3AM con la mente acelerada'
}, {
  icon: WindIcon,
  text: 'Hinchazón después de las comidas, incluso las ligeras'
}, {
  icon: BrainIcon,
  text: 'Niebla mental y falta de concentración por la tarde'
}, {
  icon: HeartIcon,
  text: 'Ansiedad injustificada al final del día'
}, {
  icon: BatteryLowIcon,
  text: 'Agotamiento crónico que no mejora con el sueño'
}];
export function Problem() {
  return <section className="py-20 lg:py-32 bg-[#FDFAF6]" data-id="element-176">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-178">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2D5A34] text-center mb-4" data-id="element-179">
            ¿Te identificas con esto?
          </h2>
          <p className="text-gray-600 italic text-center mb-12" data-id="element-180">
            Si marcaste 3 o más, tu cuerpo necesita un reseteo hormonal.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12" data-id="element-181">
            {symptoms.map((symptom, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className="bg-white rounded-xl p-6 border-l-4 border-[#C2856A] shadow-sm" data-id="element-182">
                <symptom.icon className="w-8 h-8 text-[#C2856A] mb-3" data-id="element-183" />
                <p className="text-[#2D2D2D]" data-id="element-184">{symptom.text}</p>
              </motion.div>)}
          </div>

          <p className="text-lg text-[#2D2D2D] text-center max-w-3xl mx-auto mb-6" data-id="element-185">
            No estás perdiendo la voluntad. Estás perdiendo la batalla contra tu
            nueva química hormonal. Después de los 40, las reglas del juego
            cambian — y nadie te lo explicó.
          </p>

          <p className="text-xl font-bold italic text-[#C2856A] text-center max-w-2xl mx-auto" data-id="element-186">
            El consejo de comer menos y moverte más no solo no funciona después
            de los 40. Puede estar saboteándote activamente.
          </p>
        </motion.div>
      </div>
    </section>;
}